import { gql } from '__generated__'

export const GetResumeUrl = gql(/* GraphQL */ `
    query DownloadResume($documentId: String!) {
        download(documentId: $documentId) {
            url
        }
    }
`)
